import { render, staticRenderFns } from "./TheLayoutDrawer.vue?vue&type=template&id=6c0a480e&scoped=true"
import script from "./TheLayoutDrawer.vue?vue&type=script&lang=js"
export * from "./TheLayoutDrawer.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutDrawer.vue?vue&type=style&index=0&id=6c0a480e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a480e",
  null
  
)

export default component.exports